import {API, Endpoints} from "@brg/api";
import {setBookCardT} from "../../features/QueuePaymenrt/slices/OrderSlice";

interface IBookData {
    chapterIds?: string[]
    addIds?: string[]
    removeIds?: string[]
}

export const UpsertBookData = (bookId: string, bookData: IBookData, setIsLoading: (val: boolean) => void, dispatch: any) => {

    if (!bookId) return

    setIsLoading(true)

    API.request()
        .post()
        .endpoint(Endpoints.cardsMnePw)
        .url(`api/BookCard/${bookId}/UpsertBookData`)
        .body({...bookData, bookId})
        .send()
        .then(() => {
            setTimeout(() => {
                dispatch(setBookCardT({
                    bookCardT: Date.now()
                }))
                setIsLoading(false)
            }, 1000)
        })
}import {API, Endpoints} from "@brg/api";
import {setBookCardT} from "../../features/QueuePaymenrt/slices/OrderSlice";

interface IBookData {
    chapterIds?: string[]
    addIds?: string[]
    removeIds?: string[]
}

export const UpsertBookData = (bookId: string, bookData: IBookData, setIsLoading: (val: boolean) => void, dispatch: any) => {

    if (!bookId) return

    setIsLoading(true)

    API.request()
        .post()
        .endpoint(Endpoints.cardsMnePw)
        .url(`api/BookCard/${bookId}/UpsertBookData`)
        .body({...bookData, bookId})
        .send()
        .then(() => {
            setTimeout(() => {
                dispatch(setBookCardT({
                    bookCardT: Date.now()
                }))
                setIsLoading(false)
            }, 1000)
        })
}